module.exports = __webpack_public_path__ + "img/grand-room-4.156ff331.jpg";